module.exports = __webpack_public_path__ + "p6_img1.jpg?037f1af2b8ddb03c6bfe7762ddcb6ef1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img1.jpg
// module id = 126
// module chunks = 0